// extracted by mini-css-extract-plugin
export default {"container":"Filters_container__QumvJ","block":"Filters_block__bMpZq","block_title":"Filters_block_title__IPaTe"};